export default __webpack_public_path__ + "static/media/wishlist_art.63d527c7.svg";